import _slicedToArray from 'babel-runtime/helpers/slicedToArray';
/* eslint-disable react-hooks/rules-of-hooks */
import React, { Fragment, useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import CustomCollectionGallery from '../../components/CustomCollectionGallery/CustomCollectionGallery';
import CustomCollectionDetails from '../../components/CustomCollectionDetails/CustomCollectionDetails';
import CustomCollectionStep from '../../components/CustomCollectionStep/CustomCollectionStep';

import CustomCollectionPanoRoom from '../CustomCollectionPanoRoom/CustomCollectionPanoRoom';

import ProductModal from '../../components/ProductModal/ProductModal';
import { addProductAndVariantIds, getStepsData } from '../../Utils/CustomCollectionUtils';
import { StyledGridDiv, StyledCheckoutDiv } from './CustomCollectionStyles';

var _ref = React.createElement(
  'p',
  null,
  'Finished Creating Your Look?'
);

var CustomCollection = function CustomCollection(props) {
  if (!Object.keys(props.gsData).length) return null; // wait for gsData
  var productsWithIds = addProductAndVariantIds(props.products);
  var steps = getStepsData(props.gsData.steps, productsWithIds);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      modalActive = _useState2[0],
      setModalActive = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      modalProduct = _useState4[0],
      setModalProduct = _useState4[1];

  useEffect(function () {
    // on props.isCartOpen change,
    // close modal
    if (props.isCartOpen === true) {
      setModalActive(false);
    }
  }, [props.isCartOpen]);

  var openProductModal = function openProductModal(product) {
    setModalProduct(product);
    setModalActive(true);
  };
  var closeProductModal = function closeProductModal() {
    setModalActive(false);
  };

  if (props.roomPanoCollectionId) {
    return React.createElement(
      Fragment,
      null,
      React.createElement(CustomCollectionPanoRoom, {
        title: props.title,
        descriptionHtml: props.descriptionHtml,
        roomPanoCollectionId: props.roomPanoCollectionId,
        steps: steps,
        collectionImage: props.collectionImage,
        addVariantToCart: props.addVariantToCart,
        checkout: props.checkout,
        collectionTitle: props.title,
        openProductModal: openProductModal,
        wishlistProducts: props.wishlistProducts,
        toggleAccountModal: props.toggleAccountModal,
        customCollectionImages: props.customCollectionImages
      })
    );
  } else {
    return React.createElement(
      Fragment,
      null,
      React.createElement(
        StyledGridDiv,
        null,
        React.createElement(CustomCollectionGallery, {
          collectionImage: props.collectionImage,
          customCollectionImages: Object.values(props.customCollectionImages)
        }),
        React.createElement(
          'div',
          null,
          React.createElement(CustomCollectionDetails, {
            title: props.title,
            descriptionHtml: props.descriptionHtml
          }),
          steps.map(function (step) {
            return React.createElement(CustomCollectionStep, {
              key: step.title,
              step: step,
              addVariantToCart: props.addVariantToCart,
              roomPanoCollectionId: props.roomPanoCollectionId,
              checkout: props.checkout,
              collectionTitle: props.title,
              openProductModal: openProductModal,
              wishlistProducts: props.wishlistProducts,
              toggleAccountModal: props.toggleAccountModal
            });
          })
        )
      ),
      React.createElement(
        StyledCheckoutDiv,
        { className: 'custom-collection__checkout-div' },
        _ref,
        React.createElement(
          'button',
          {
            className: 'btn btn--full gradient-shimmer',
            onClick: props.handleCartOpen
          },
          'Proceed To Cart'
        )
      ),
      React.createElement(ProductModal, {
        active: modalActive,
        product: modalProduct,
        addVariantToCart: props.addVariantToCart,
        checkout: props.checkout,
        closeProductModal: closeProductModal
      })
    );
  }
};

CustomCollection.propTypes = {
  title: PropTypes.string.isRequired,
  descriptionHtml: PropTypes.string.isRequired,
  products: PropTypes.array.isRequired,
  fetchingMoreData: PropTypes.bool,
  gsData: PropTypes.object,
  collectionImage: PropTypes.string,
  customCollectionImages: PropTypes.object,
  isCartOpen: PropTypes.bool,
  wishlistProducts: PropTypes.array,
  handleCartOpen: PropTypes.func,
  addVariantToCart: PropTypes.func.isRequired,
  checkout: PropTypes.object.isRequired,
  toggleAccountModal: PropTypes.func.isRequired
};

export default CustomCollection;